import { useSubgeoStore } from '@/features/subgeo/store/subgeo-store'
import { NeighborhoodSearch } from './neighborhood-search'
import { SidebarTabs } from './sidebar-tabs'
import { SubgeoList } from './subgeo-list'

interface SidebarViewProps {
	isLoading?: boolean
	onNeighborhoodClick: (neighborhoodId: string) => void
}

export const SidebarView = ({
	isLoading = false,
	onNeighborhoodClick
}: SidebarViewProps) => {
	const { activeTab, setHighlightedNeighborhood } = useSubgeoStore()

	const handleNeighborhoodClick = (neighborhoodId: string) => {
		setHighlightedNeighborhood(neighborhoodId)
		onNeighborhoodClick(neighborhoodId)
	}

	return (
		<div className='flex h-[calc(100dvh-80px)] w-full flex-col gap-0 overflow-hidden rounded-xl border border-neutral-300 bg-neutral-white pb-2.5'>
			<SidebarTabs />
			{activeTab === 'subgeos' ? (
				<SubgeoList isLoading={isLoading} />
			) : (
				<NeighborhoodSearch
					isLoading={isLoading}
					onNeighborhoodClick={handleNeighborhoodClick}
				/>
			)}
		</div>
	)
}
